// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgpp-legal-review-container {
  width: 100%;
}
.tgpp-legal-review-container .tgpp-legal-review-content {
  margin: 20px 10px 5px 10px;
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.tgpp-legal-review-container .tgpp-legal-review-content mat-checkbox label {
  display: block !important;
}
.tgpp-legal-review-container .tgpp-legal-review-content mat-checkbox td {
  white-space: break-spaces;
}

.help-legal-reviewer {
  margin-top: -16px;
  margin-bottom: 10px;
}

.legalreview-padding {
  padding-top: 10px;
}

.reviewer-display {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/add-edit-legal-review/add-edit-legal-review.component.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;AAGE;EACE,0BAAA;EACA,+HAAA;AADJ;AAGM;EACE,yBAAA;AADR;AAIM;EACE,yBAAA;AAFR;;AASA;EACE,iBAAA;EACA,mBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,cAAA;AANF","sourcesContent":["$form-field-margin: 10px;\n\n.tgpp-legal-review-container {\n  width: 100%;\n\n  .tgpp-legal-review-content {\n    margin: 20px 10px 5px 10px;\n    /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */\n    mat-checkbox {\n      label {\n        display: block !important;\n      }\n\n      td {\n        white-space: break-spaces;\n      }\n    }\n\n  }\n}\n\n.help-legal-reviewer {\n  margin-top: -16px;\n  margin-bottom: 10px;\n}\n\n.legalreview-padding {\n  padding-top: 10px;\n}\n\n.reviewer-display {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
